<button
  type="button"
  class="sidebar-brand btn border-0 bg-transparent d-flex align-items-center gap-3 mb-0 px-1 pt-1 me-auto text-start"
  @click="$emit('brand-click')"
  aria-label="Open Portfolio Comparisons"
>

  <!-- Short Logo -->
  <div class="sidebar-brand-logo sidebar-logo mb-2 rounded-3 shadow-sm border border-light border-opacity-25"></div>


  <!-- Brand Title + Subtitle -->
  <div class="sidebar-brand-copy d-flex flex-column mt-2">
    <p class="brand-title text-dark text-uppercase fw-semibold text-xs mb-1">{{ title }}</p>
    <p class="brand-subtitle text-muted text-uppercase fw-medium text-xxs mb-0">{{ subtitle }}</p>
  </div>

</button>
